module.exports = __webpack_public_path__ + "img/order_header_image_mobile.de583bb1.png";